/**
 * iter87.230 — NFL/CFB Playoffs. Sibling of potPlayoffsTemplates.js
 * (MLB/NBA) but deliberately separate: no Champions Pick, no Series
 * Predictor — football's only pre-season mechanic is the Team Pick
 * Pot (1 from Pot 1, 2 from Pot 2, 2 from Pot 3), scored by ROUND
 * (6 → 8 → 10 → 12), plus the in-season Weekly Spread Boost between
 * bracket rounds (reused from matchday_boost.py — 2 picks/round, 1
 * for the Super Bowl / National Championship).
 */
export const FOOTBALL_PLAYOFFS_LABELS = {
    nfl_playoffs_api: "NFL Playoffs",
    cfb_playoffs_api: "CFB Playoffs",
};

export const isFootballPlayoffsTemplate = (template) =>
    Object.prototype.hasOwnProperty.call(FOOTBALL_PLAYOFFS_LABELS, template);
